<template>
  <div>
    <el-dialog
      :title="folderTreeDialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <div v-loading="loading">
        <el-tree
          ref="folderTree"
          node-key="id"
          :data="folderTreeData"
          :props="defaultProps"
          :check-on-click-node="true"
          :highlight-current="true"
          :expand-on-click-node="false"
          :current-node-key="currentNodeKey"
          :default-expanded-keys="defaultExpandedKeys"
        ></el-tree>
      </div>

      <div slot="footer" style="text-align: right">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleOk">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../../util/request";

export default {
  data() {
    return {
      loading: false,
      folderTreeData: [],
      defaultProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      dialogVisible: false,
    };
  },
  props: {
    folderTreeDialogType: { type: Number, default: 0 },
    folderTreeDialogTitle: { type: String, default: "移动到" },
    currentNodeKey: { type: Number, default: 0 },
    defaultExpandedKeys: { type: Array, default: [0] },
    folderTreeDialogId: { type: Number, default: 0 },
  },
  created() {},
  methods: {
    show() {
      this.getFolderTreeList();
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    getFolderTreeList() {
      this.loading = true;
      axiosRequest(
        "/user-report/folder-tree-list",
        {},
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.folderTreeData = [
              {
                id: 0,
                name: "我的创作",
                isLeaf: false,
                children: res.data.data,
              },
            ];
            this.$nextTick(() => {
              this.$refs.folderTree.setCurrentKey(this.currentNodeKey);
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleOk() {
      axiosRequest(
        "/user-report/report-move-copy",
        {
          type: this.folderTreeDialogType,
          id: this.folderTreeDialogId,
          folderId: this.$refs.folderTree.getCurrentKey(),
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.hide();
            this.$emit("refreshData");
          }
        })
        .catch(() => {});
    },
  },
};
</script>
